/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import {
  DashboardStats,
  DeviceAlertRow,
  EnrolledDeviceInformation,
  InsecureDeviceInformation,
  Stats,
} from '../../types/DeviceTypes'
import { DeviceEvent } from '../../types/DeviceEventTypes'
import { DeviceForensicsResponse } from '../../types/DeviceForensicTypes'

export interface DeviceState {
  devices: EnrolledDeviceInformation[] | undefined
  totalPages: number
  deviceTableCurrentPage: number
  insecureDevices: InsecureDeviceInformation[] | undefined
  dashboardDeviceStats: DashboardStats | undefined
  dashboardDevicesCreatedStat: Stats | undefined
  dashboardAlertsCreatedStat: Stats | undefined
  dashboardTotalScansStat: Stats | undefined
  dashboardInsecureDevicesStat: Stats | undefined
  deviceAlerts: DeviceAlertRow[] | undefined
  deviceDetails: EnrolledDeviceInformation | undefined
  deviceDetailsScreen: string
  deviceEvents: DeviceEvent[] | undefined
  deviceForensics: DeviceForensicsResponse | undefined
  totalPagesDeviceEvents: number
  currentPageDeviceEvents: number
  iosSupportedVersions: string[] | undefined
}

const initialState: DeviceState = {
  devices: undefined,
  totalPages: 1,
  deviceTableCurrentPage: 1,
  insecureDevices: undefined,
  dashboardDeviceStats: undefined,
  dashboardDevicesCreatedStat: undefined,
  dashboardAlertsCreatedStat: undefined,
  dashboardTotalScansStat: undefined,
  dashboardInsecureDevicesStat: undefined,
  deviceAlerts: undefined,
  deviceDetails: undefined,
  deviceDetailsScreen: 'overview',
  deviceEvents: undefined,
  deviceForensics: undefined,
  totalPagesDeviceEvents: 1,
  currentPageDeviceEvents: 1,
  iosSupportedVersions: undefined,
}

export const deviceSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setDevices(state, action: PayloadAction<any>) {
      state.devices = action.payload
    },
    setTotalPages(state, action: PayloadAction<any>) {
      state.totalPages = action.payload
    },
    setDeviceTableCurrentPage(state, action: PayloadAction<any>) {
      state.deviceTableCurrentPage = action.payload
    },
    setInsecureDevices(state, action: PayloadAction<any>) {
      state.insecureDevices = action.payload
    },
    setDashboardDeviceStats(state, action: PayloadAction<any>) {
      state.dashboardDeviceStats = action.payload
    },
    setDashboardDevicesCreatedStat(state, action: PayloadAction<any>) {
      state.dashboardDevicesCreatedStat = action.payload
    },
    setDashboardAlertsCreatedStat(state, action: PayloadAction<any>) {
      state.dashboardAlertsCreatedStat = action.payload
    },
    setDashboardTotalScansStat(state, action: PayloadAction<any>) {
      state.dashboardTotalScansStat = action.payload
    },
    setDashboardInsecureDevicesStat(state, action: PayloadAction<any>) {
      state.dashboardInsecureDevicesStat = action.payload
    },
    setDeviceAlerts(state, action: PayloadAction<any>) {
      state.deviceAlerts = action.payload
    },
    setDeviceDetails(state, action: PayloadAction<any>) {
      state.deviceDetails = action.payload
    },
    setDeviceDetailsScreen(state, action: PayloadAction<any>) {
      state.deviceDetailsScreen = action.payload
    },
    setDeviceEvents(state, action: PayloadAction<DeviceEvent[] | undefined>) {
      state.deviceEvents = action.payload
    },
    setTotalPagesDeviceEvents(state, action: PayloadAction<number>) {
      state.totalPagesDeviceEvents = action.payload
    },
    setCurrentPageDeviceEvents(state, action: PayloadAction<number>) {
      state.currentPageDeviceEvents = action.payload
    },
    setDeviceForensics(state, action: PayloadAction<DeviceForensicsResponse | undefined>) {
      state.deviceForensics = action.payload
    },
    setIosSupportedVersions(state, action: PayloadAction<any>) {
      state.iosSupportedVersions = action.payload
    },
  },
})
export const selectDevices = (state: RootState) => state.devices

export const {
  setDevices,
  setTotalPages,
  setDeviceTableCurrentPage,
  setInsecureDevices,
  setDashboardDeviceStats,
  setDashboardDevicesCreatedStat,
  setDashboardAlertsCreatedStat,
  setDashboardTotalScansStat,
  setDashboardInsecureDevicesStat,
  setDeviceAlerts,
  setDeviceDetails,
  setDeviceDetailsScreen,
  setDeviceEvents,
  setTotalPagesDeviceEvents,
  setCurrentPageDeviceEvents,
  setDeviceForensics,
  setIosSupportedVersions,
} = deviceSlice.actions
export default deviceSlice.reducer
